import { render, staticRenderFns } from "./Dependencias.vue?vue&type=template&id=08c58aab"
import script from "./Dependencias.vue?vue&type=script&lang=js"
export * from "./Dependencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports